import LocalizedLink from '@components/Localization/LocalizedLink'
import { CleanLink } from '@components/gassan-ui/Link/CleanLink'
import { Icon, Link as RolexLink } from '@components/old-rolex-ui'
import { cn } from '@lib/cn'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import React from 'react'

const RCPOFooter: React.FC = () => {
  const router = useRouter()
  const {
    t,
    i18n: { language },
  } = useTranslation('navigation')

  const navItems: { label: string; href: string }[] = [
    {
      label: t('rcpo.index.title'),
      href: `${t('rcpo.index.url')}`,
    },
    {
      label: t('rcpo.selection.title'),
      href: `${t('rcpo.selection.url')}`,
    },
    {
      label: t('rcpo.certification.title'),
      href: `${t('rcpo.certification.url')}`,
    },
    {
      label: t('rcpo.contact.title'),
      href: `${t('rcpo.contact.url')}`,
    },
  ]

  return (
    <div className="relative grid w-full grid-flow-row auto-rows-auto gap-6 py-16 md:items-center md:py-24">
      <div className="row-span-1 row-start-2 flex w-full justify-center md:row-start-1">
        <CleanLink
          href={
            language === 'nl'
              ? '/rolex-certified-pre-owned'
              : `/${language}/rolex-certified-pre-owned`
          }
        >
          <img
            src="/images/rolex/rolex_logo_full_colour.png"
            alt="Rolex retailer plaque"
            className={cn('h-[40px] w-[70px]', 'md:h-[50px] md:w-[88px]')}
          />
        </CleanLink>
      </div>
      <nav className="flex w-full flex-col items-center border-t border-shade-200 md:flex-row md:justify-center md:gap-8 md:border-y md:border-shade-200 md:py-4">
        {navItems.map((item, key) => {
          const cleanHref = item.href.replace(`/${language}`, '')
          const isActive = cleanHref === router.asPath
          return (
            <LocalizedLink href={item.href} key={key}>
              <RolexLink
                type="link"
                variant="primary"
                className={cn(
                  'h-12 w-full justify-center border-b border-shade-200 md:h-auto md:w-auto md:border-none ',
                  isActive ? 'text-rolexPrimary' : '!text-rolexShade-900',
                )}
              >
                {item.label}
              </RolexLink>
            </LocalizedLink>
          )
        })}
      </nav>
      <button
        className={cn(
          'flex h-10 w-10 items-center justify-center justify-self-center rounded-full border-none bg-rolexPrimary text-white outline-none transition-colors duration-150',
          'hover:bg-rolexGreenDark',
        )}
        onClick={() => scrollToTop()}
      >
        <Icon icon="rolex-back-to-top-arrow" />
      </button>
    </div>
  )

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
}

export default RCPOFooter
